export default "__VITE_ASSET__BV$ECD00__"